<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ this.$store.state.modal.content.title }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <div class="mb16">
            <label class="fsp14 lh20 text-black mb8">Verified</label>
            <SelectSimple
                id="verified"
                :defaultValue="'All'"
                :keywords.sync="this.verifiedList"
                :hotUpdate="true"
                :dataValue="this.fields.verified" 
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Ownership</label>
            <SelectSimple
                id="ownership"
                :defaultValue="'All'"
                :keywords.sync="this.ownershipList"
                :hotUpdate="true"
                :dataValue="this.fields.ownership" 
                @updateParentState="this.updateState"
            />
        </div>
        <div class="d-flex align-items-center w-100" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-warning" class="equal-width h48 mr16" @click="this.save()">Apply</Button>
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">Clear All</Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/service/Button.vue';
import SelectSimple from '@/components/service/SelectSimple.vue';
import Icon from '@/components/icons/Icon.vue';
export default {
    name: 'OwnershipFilter',
    components: {
        Button,
        SelectSimple,
        Icon
    },
    props: {
        close: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            callback: null,
            fields: {
                verified: null,
                ownership: null,
            },
            verifiedList: [
                { code: null, name: 'All' },
                { code: 'true', name: 'Verified' },
                { code: 'false', name: 'Not Verified' }
            ],
            ownershipList: [
                { code: null, name: 'All' },
                { code: 'custodian', name: 'Custodian' },
                { code: 'selfhosted_mine', name: 'Selfhosted Mine' },
                { code: 'selfhosted_3dparty', name: 'Selfhosted 3rd Party' },
                { code: 'selfhosted_unknown', name: 'Selfhosted Unknown' },
                { code: 'not_found', name: 'Not Found' }
            ]
        }
    },
    mounted() {
        this.callback = this.$store.state.modal.content.callback;
        this.fields = this.$store.state.modal.content.fields;
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        updateState(arg) {
            this.fields[arg.id] = arg.value;
        },
        save() {
            this.callback(this.fields);
            this.close();
        },
        clearAll() {
            Object.keys(this.fields).forEach(field => {
                this.fields[field] = null;
            });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
